import React ,  { useState }  from "react"

import { Container} from "@material-ui/core"
import Layout from "../../components/Layout"
import CTA from "../../components/CTA"

import Hero from "./../../components/Hero"



import data from '../../assets/services/ai-ml/data-preparation.png'
import choice from '../../assets/services/ai-ml/problem-Solution-fit.png'
import performance from '../../assets/services/ai-ml/solution-sustenance.png'


import nlp from '../../assets/services/ai-ml/nlp.jpg'
import comp_v from '../../assets/services/ai-ml/computer-vision.jpg'
import ml from '../../assets/services/ai-ml/ml.jpg'





function Page() {

  const [status, setStatus] = useState(1);
  return (
    <Layout
      cssClass="ai-ml-page services--page"
      title="INVIZ AI Solutions | AI & Machine Learning"
      description="We are a global software and intelligence consultancy company focused on building software, cloud and data solutions with intelligence."
    >

      <Hero>        
        <p className="xlarge">AI &amp; ML is about making fast &amp; accurate decisions </p>
      </Hero>    



      <section className={`ai-ml__solutions status_${status}`}>

     
        <Container>
        <div className="text-center">
          <p>
          We help companies build applications that adapt to various business stimuli, with minimal manual intervention. we add intelligence to your systems enabling them to take decisions, decision that are faster and accurate, resulting in superior customer experience and competitive advantage.   
          </p>
          <br />
          </div>
        </Container>
     
        <div className="tabs">            
              <b className={status===1? 'active' : ''} onClick={() => setStatus(1)}>NLP Solutions</b>         
              <b className={status===2? 'active' : ''} onClick={() => setStatus(2)}>Computer Vision Solutions</b>            
              <b className={status===3? 'active' : ''} onClick={() => setStatus(3)}>ML &amp; AI Solutions</b>
          </div>
        <Container>
          
          <div className={`tabs__content tabs__content__${status}`}>
            <div className="flex">
            <div className="ai-ml__solutions__solution tabs__content__item">
              <figure>
                <img src={nlp} alt="Natural Language Processing ( NLP ) solutions"/>
              </figure>
              <div className="text">
                <h4>
                  <b className="green"> Natural Language Processing ( NLP ) solutions</b>
                </h4>
                <ul>
                  <li><span>Enable your systems,like a human does, to understand meaning from textual and visual content.</span></li>
                  <li><span>Transform customer experience by enabling machines to understand customer intent and sentiments.</span></li>
                  <li><span>Build advanced chat bots to improve customer engagements and deliver a uniform experience at lowered costs and risks.</span></li>
                  <li><span>Use NLP to gain competitive edge in market intelligence, advertising, merchandising and other business functions.</span></li>
                </ul>
              </div>
            </div>
            <div className="ai-ml__solutions__solution">
            <figure>
                <img src={comp_v} alt="Computer Vision Solutions"/>
              </figure>
              <div className="text">
                <h4>
                  <b className="green">Computer Vision Solutions</b>
                </h4>
                <p>Enable your systems to develop the ability to observe, analyse and gather information &amp; intelligence.</p>
                <ul>
                  <li><span>Identify/ predict component failures in machines</span></li>
                  <li><span>Entity attribute extraction - Generate product information from images</span></li>
                  <li><span>Identify customer emotions and sentiments</span></li>
                  <li><span>Computer vision based planograms</span></li>
                </ul>
              </div>
            </div>    
            <div className="ai-ml__solutions__solution">
            <figure>
                <img src={ml} alt="Bespoke ML and AI solutions"/>
              </figure>
              <div className="text">
                <h4>
                  <b className="green">Bespoke ML &amp; AI solutions</b>
                </h4>
                <p>Use your data to identify patterns and trends across various business functions</p>
                <ul>
                  <li><span>Smart forecasting</span></li>
                  <li><span>Predicting impending risks / issues</span></li>
                  <li><span>Empowering data-driven business decisions</span></li>
                </ul>
                
              </div>
            </div>               
          </div>
          </div>
        </Container>
      </section>

      <section className="three-fold-framework">
        <Container>
          <header>
          <h3><strong>Inviz’s</strong>
            <strong className="green">3-Fold Framework</strong>
          </h3>
          </header>
          
          <div className="items">
              <div className="item_">
                <figure><img src={data} alt="Data Pre-processing"/></figure>
                <div className="text">
                  <h4 className="green">                  
                  <strong>Data Preparation</strong>   
                  </h4>
                  <p>
                  Your decisions are only as good as your data. 
                  We add magic to your data by removing the noise and retaining the information that matters.
                  </p>  
                  </div>            
              </div>
              <div className="item_">
                <figure><img src={choice} alt="When to Apply What"/></figure>
                <div className="text">
                  <h4 className="green">
                  <strong>Identifying Problem-Solution Fit</strong>                
                  </h4>
                  <p>
                  Using the appropriate tool to solve a specific problem reduces effort, minimizes resource utilization & delivers effective results. 
                  In business scenarios, these capabilities help us deliver effective solutions in a timely manner. 
                  </p>
                  </div>
                
              </div>
              <div className="item_">
                <figure><img src={performance} alt="Performance Measurement &amp; Retraining / Replacement"/></figure>
                  <div className="text">
                  <h4 className="green">                  
                  <strong>Solution Sustenance</strong>                 
                  </h4>
                  <p>
                  Business environments change constantly. These changes introduce unpredictability that may make the solutions less effective. 
                  Hence ML and AI model re-training / replacement is necessary to ensure consistent business value delivery.
                  </p> 
                  </div>             
            </div>
            </div>
         
        </Container>
      </section>
      <section className="domains">
        <Container>
        <header className="centered">
          <h3><strong>Business Value <span className="green"></span></strong></h3>
        </header>
        <ul className="flex">
          <li className="xs-6 md-3">
            <div className="mfg">
              <h4><b>Manufacturing</b></h4>
              <p>Reduce costs and unplanned downtime while enhancing operational efficiencies</p>
            </div>
          </li>
          <li  className="xs-6 md-3">
            <div className="retail"><h4><b>Retail</b></h4>
              <p>Boost your sales by enhancing customer engagement and experience</p></div>
          </li>
          <li  className="xs-6 md-3">
            <div className="finance"><h4><b>Finance</b></h4>
              <p>Leverage AI to prevent fraud, increase relevancy and personalization to reach more customers</p></div>
          </li>
          <li  className="xs-6 md-3">
            <div className="health"><h4><b>Health Care</b></h4>
              <p>Increase decision making ability for health practitioners and overall experience of the patience</p></div>
          </li>
        </ul>
        </Container>
      </section>


    
      <CTA>
      If you feel, we could help <b className="green">solve your business problem</b>,          
      </CTA>
    </Layout>
  )
}

export default Page



